// extracted by mini-css-extract-plugin
export default {"txPreview":"styles_txPreview__b+y52"};